import { Location } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { JobListData } from "../../../jobsAndTalents/jobs/interface/jobs-list.interface";
import { AppDataViewResponse, SystemListingPageField, SystemPage } from "../../interface/appDataView/app-data-view.interface";
import { ReponseData } from "../../interface/Icommon";
import { ClientConfiguation } from "../../_enums/clientConfiguration";
import { AlignOrder, ExportType, ListType, StatusCode } from "../../_enums/Common";
import { FileInfo } from "../../_models/common/BaseModel";
import { ListingParams } from "../../_models/common/listingParams";
import { FormConfigModel } from "../../_models/Layout/FormConfig";
import { SavedSearch, SearchOptions } from "../../_models/search/searchOptions";
import { CommonService } from "@services/app.common.service";
import { DataPassService } from "@services/app.datapass.service";
import { ExcelExportService } from "@services/excel-export.service";
import { ExcelExportModalComponent } from "./excel-export-modal/excel-export-modal.component";


@Component({
  selector: 'app-print-and-export',
  templateUrl: './printAndExport.component.html',
  styleUrls: ['./printAndExport.component.css']
})
export class PrintAndExportComponent implements OnInit, OnDestroy {
  @Output() showSavedSearch = new EventEmitter<SavedSearch>();
  @Output() byClick: EventEmitter<any> = new EventEmitter();
  @Output() byLoaded: EventEmitter<any> = new EventEmitter();
  @Input() inputParams = {} as ListingParams;
  @Input() hidePrintExport?: Boolean = false;
  @Input() showTitle?: string = 'true';
  @Input() filters: any;
  @ViewChild('template') modal: any;
  @ViewChild(ExcelExportModalComponent)excelExportModalComponent!: ExcelExportModalComponent;

  //@ViewChild(ExcelExportModalComponent, { static: true }) excelExportModalComponent?: ExcelExportModalComponent;


  public pageFields : SystemListingPageField[] = [];
  public listOfData : any[]=[];
  public properties: any[] = [];
  public showingRecordStart :  number=0;
  public showingRecordEnd: number = 0;
  public pagingDataExcelExport : any;
  public RefId: string = "";
  public pageNo: number = 1;
  public totalRows :  number=0;
  public totalPages: number | undefined;
  public modalConfig = {} as FormConfigModel;
  public serverExport: boolean = false;
  fileName: string = "";
  public ngOnDestroy() {

    var paras = document.getElementsByClassName('ExportxlsClass');

    while (paras[0]) {
      paras[0].parentNode?.removeChild(paras[0]);
    }
  }

  constructor(
    private _location: Location,
    private common: CommonService,
    public dataPassService: DataPassService,
    public excelExportService: ExcelExportService,
    private router: Router

  ) {


  }
  public openPrint(): void {
    // this.printExport.show();
  }

  public closePrint() {
    // this.printExport.hide();
  }

  ngOnInit(): void {
    
    this.hidePrintExport = true;
    if (this.showTitle == 'true')
      this.common.setTitle('Common.PrintPreview');

      this.modalConfig.hideDefaultAction = true;
      this.modalConfig.hideCard = false;
    //this.inputParams = this.dataPassService.printParams;
    this.inputParams = this.common.JsonParseData(this.common.GetFromSessionStorage('print_data'));

    if (!this.common.isNullOrWhiteSpace(this.inputParams)) {
      this.pageNo = this.inputParams.pageNo;
      if (this.pageNo == undefined)
      this.pageNo = 1;
      this.getListOfData(ExportType.Word);
    }
      this.serverExport = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.ServerExport))
      if (this.router.url === '/Shared/PrintPreview') {
        this.hidePrintExport = false;
    }
    this.fileName = `${this.common.normalizedFileName(this.common.getDocumentTitle())} ${this.common.formatDate(Date.now(), 'Do MMM YYYY')}`;
  }

  public getListOfData(exportType: string) {
    let showLoader = true;
    if (this.inputParams.systemPageId != -1) {
      this.inputParams.sortDirection = this.inputParams.isAscendingSort ? AlignOrder.Asc : AlignOrder.Desc;
      let params;
      params = {
        IsAscendingSort: this.inputParams.isAscendingSort ? true : false,
        SortColumn: this.inputParams.sortColumn,
        PageSize: this.inputParams.pageSize,
        Skip: ((this.pageNo - 1) * this.inputParams.pageSize),
        TextToSearch: this.inputParams.textToSearch,
        SystemPageId: this.inputParams.systemPageId,
        IdToSearch: this.inputParams.idToSearch,
        ScreenName: this.inputParams.screenName,
        ControllerName: this.inputParams.controllerName,
        SearchOptions: this.inputParams.searchOptions,
        CandidateId: this.inputParams.candidateId,
        SortDirection: this.inputParams.sortDirection,
        showArchived: this.inputParams.showArchived,
        Filters: this.filters,
        action: ListType.Print,
        jobId: this.inputParams.jobId,
        ExportType: exportType,
        viewIncomplete: this.inputParams.viewIncomplete
      };

      //if (this.inputParams.multiPages == true) {
      //  params.Skip = 0;
      //  params.PageSize = 500;
      //  if (exportType == ExportType.Excel)
      //    params.PageSize = 500;


      //}

      if (exportType == ExportType.Excel && this.serverExport) {
        if (this.inputParams.selectedRecords.length > 0) {
          this.excelExportModalComponent?.openModal(this.inputParams, this.pageNo);
          this.excelExportModalComponent?.closeModal();
          this.excelExportModalComponent?.startExport();
         
        }
        else {
          this.excelExportModalComponent?.openModal(this.inputParams, this.pageNo);
        }
        return;
      }


      this.common.PostData(this.inputParams.getUrl, params, showLoader).then(data => {

        var response = data;
        if (response.status == StatusCode.OK) {


          if (!this.common.isNullOrWhiteSpace(response.resultData.excelFile) && exportType == ExportType.Excel) {
            const random = Math.floor(Math.random() * (999999 - 100000)) + 100000;
            const fileName = this.common.normalizedFileName(this.common.getDocumentTitle()) + '_' + this.common.formatDate(Date.now(), 'dddd, MMMM Do YYYY, HH:mm:ss');
            const file: FileInfo = {
              name: fileName + '.xlsx',
              type: 'XLSX',
              content: response.resultData.excelFile,
              browserType: '',
              extention: 'XLSX'


            }

            this.common.DownLoadFile(file);
            this.common.Loader.hide();
            return;
          }
          //this.excelExportService.gridViewToFile(response);
          // this.excelExportModalComponent.exportModal.show()
          // return;
          this.listOfData = response.resultData.listData;
          if (this.listOfData[0] != null) {
            this.properties = Object.getOwnPropertyNames(this.listOfData[0]);
          }

          response.resultData = this.formateData(response.resultData);
          this.pagingDataExcelExport = response.resultData;
          this.pageFields = response.resultData.headerData;


          //for (var i = 0; i < this.listOfData.length; i++) {
          //  if (this.listOfData[i].VisibleTo != 'undefined')
          //  {
          //    if (this.listOfData[i].VisibleTo.external == 'true')
          //      this.listOfData[i].VisibleTo.external = 'external'
          //    if (this.listOfData[i].VisibleTo.internal == 'true')
          //      this.listOfData[i].VisibleTo.external = 'internal'
          //    if (this.listOfData[i].VisibleTo.agency == 'true')
          //      this.listOfData[i].VisibleTo.external = 'agency'
          //  }

          // }


          let refId = '';

          if (this.inputParams.systemPageId == 165) {
            refId = this.inputParams.refId;
          } else {
            refId = response.resultData.refId;
          }

          if (this.inputParams.printSelectedRecords == true && this.inputParams.selectedRecords.length > 0) {
            const that = this;
            this.listOfData = this.listOfData.filter(function (item) {
              return that.inputParams.selectedRecords.includes(item[refId]);
            });
          }

          this.RefId = response.resultData.refId;
          this.totalRows = response.resultData.count;
          this.totalPages = Math.ceil(this.totalRows / this.inputParams.pageSize);
          this.showingRecordStart = ((this.pageNo - 1) * this.inputParams.pageSize) + 1;
          this.showingRecordEnd = (this.pageNo * this.inputParams.pageSize);
          if (this.showingRecordEnd > this.totalRows) {
            this.showingRecordEnd = this.totalRows;
          }
          if (this.listOfData[0] != null) {
            this.properties = Object.getOwnPropertyNames(this.listOfData[0]);
          }
        }
        this.dataPassService.printParams = {} as ListingParams;
        this.inputParams = {} as ListingParams;
        const that = this;
        if (exportType == ExportType.Excel) {

          setTimeout(() => {
            let element: HTMLElement = document.getElementById('btnExporttoExcel') as HTMLElement;
            if (element)
              element.click();
            that.common.Loader.hide();
          }, 200);



        } else {

          that.common.Loader.hide();
        }
      });
    }

  }
  

  public formateData(responseData: AppDataViewResponse<any, SystemPage, SystemListingPageField>) {
    const pageFields = responseData.headerData;
    const listOfData = responseData.listData;
    const systemPage = responseData.systemPage;
    for (const f in pageFields) {
      const pageField = pageFields[f];
      let propertyName = pageField.columnName;
      // this is done to avoid javascript case sensitivity issue
      if (propertyName != null && this.properties != null) {
        propertyName = this.properties.filter(function (prop) {
          return prop != null && prop.toLowerCase() == propertyName.toLowerCase();
        })[0];
        pageField.normalizedColumnName = propertyName;
      }

    }

    for (const d in listOfData) {
      const data = listOfData[d];
      for (const f in pageFields) {
        const pageField = pageFields[f];
        const propertyName = pageField.normalizedColumnName ?? "";
        const value = data[propertyName];
        if (/^[+=@-]/.test(value)) {
          data[propertyName] = '\'' + value;
        }
      }

    }
    return responseData;
  }


  public close() {
    this._location.back();
  }

  public delay(ms: number) {
    // return new Promise(resolve => setTimeout(resolve, ms));
  }
}
